module.exports = __webpack_public_path__ + "static/media/aboutus-bg.35468a28.png";